import type { CommunicationRecord } from "@entities";
import type { ColumnProps } from "@shared/frontend/hyper-table/types";
import { CommunicationRecordsTableCell } from "../../components/CommunicationRecordManager/CommunicationRecordsTableCell";

type EntityWithCommunicationRecords = {
  communicationRecords?: CommunicationRecord[];
};

export function buildCommunicationRecordsColumn<T extends EntityWithCommunicationRecords>(
  onViewAll: (entity: T) => void,
): ColumnProps<T> {
  return {
    field: "communicationRecords",
    caption: "תיעוד תקשורת",
    minSize: 170,
    enableSorting: false,
    preventRowClick: true,
    cell: ({ row }) => (
      <CommunicationRecordsTableCell
        records={row.original.communicationRecords}
        onViewAll={() => onViewAll(row.original)}
      />
    ),
  };
}
